export const DRAW_DECISION = "draw";

export function isTechnicalBonusDecision(decision) {
  return decision === "blue" || decision === "red";
}

export function canSubmitTieDecision(decision, comment = "") {
  if (decision === DRAW_DECISION) return true;
  return isTechnicalBonusDecision(decision) && comment.trim().length > 0;
}

export function applyTieDecision(totalBlue, totalRed, decision) {
  return {
    finalBlue: totalBlue + (decision === "blue" ? 1 : 0),
    finalRed: totalRed + (decision === "red" ? 1 : 0),
  };
}
